<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>文档库</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-select v-model="searchData.product" placeholder="请选择产品">
                            <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.lang" placeholder="请选择语言">
                            <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>

                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <div class="btn_right_box">
                    <div class="button button2 add" @click="add" v-if="roleCheck('103-103-101-102')">
                        <i class="el-icon-plus"></i>
                        <span>新建</span>
                    </div>
                    <div class="button button2 export" @click="inSortMode" v-if="roleCheck('103-103-101-102') && !sortState">
                        <span>排序</span>
                    </div>
                    <div class="button" @click="sortConfirm" v-if="sortState">
                        <span>确认</span>
                    </div>
                    <div class="button" @click="sortCancel" v-if="sortState">
                        <span>取消</span>
                    </div>
                </div>
            </div>
            <el-table :data="tableData" >
                <el-table-column label="产品">
                    <template slot-scope="scope">
                        <span>{{ tableMode.product }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="语言" prop="lang" >
                    <template slot-scope="scope">
                        <span>{{ appData.lang[tableMode.lang] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="文件">
                    <template slot-scope="scope">
                        <span>{{ scope.row.name.split('/_').pop() }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="大小">
                    <template slot-scope="scope">
                        <span>{{ scope.row.size/1024 < 1024 ? (scope.row.size/1024).toFixed(2) + 'KB' : (scope.row.size/1024/1024).toFixed(2) + 'M' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="button text del_btn" @click="delFile(scope.row.name)" v-if="roleCheck('103-103-101-102') && !sortState">删除</div>
                        <div class="button text del_btn" @click="sort(scope.$index, 'up')" v-if="roleCheck('103-103-101-102') && sortState && scope.$index != 0">
                            <i class="el-icon-sort-up" title="上移"></i>
                        </div>
                        <div class="button text del_btn" @click="sort(scope.$index, 'down')" v-if="roleCheck('103-103-101-102') && sortState && scope.$index != tableData.length - 1">
                            <i class="el-icon-sort-down" title="下移"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Tip ref="tip" :msg="delMsg" @tipBack="delConfirm"></Tip>
            <Gh-Dialog ref="addFileDislog" size="big" title="新增文档" @dialogBack="updateConfirm">
                <template v-slot:cancel_btn>
                    <span></span>
                </template>
                <template v-slot:content>
                    <el-form label-width="100px" :model="searchData">
                        <el-form-item label="产品">
                            <span>{{ searchData.product }}</span>
                        </el-form-item>
                        <el-form-item label="语言">
                            <span>{{ appData.lang[searchData.lang] }}</span>
                        </el-form-item>
                        <el-form-item class="block" label="文件">
                            <upload ref="create_upload" :fileDire="'product-service-center/' + fileDire" :limit="10" @fileChange="fileChange">
                                <template slot="desc">
                                    <span slot="tip" class="el-upload__tip upload_desc">{{`附件数量上限10个`}}</span>
                                </template>
                            </upload>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
import aliOss from '../../../aliOss/index'
import upload from '../../../components/file/upload'
export default({
    name: 'psc-guide-manage',
    data() {
        return {
            module: 'guide',
            searchData: {
                product: '',
                lang: ''
            },
            tableMode: {
                product: '',
                lang: ''
            },
            tableData: [],
            delDire: '',
            delMsg: '',
            sortConfig: {},
            sortState: false,
            sortData: []
        }
    },
    components: {
        upload
    },
    computed: {
        fileDire() {
            return `${this.searchData.product}/${this.searchData.lang}/${this.module}`
        }
    },
    created() {
        this.getConfig();

    },
    methods: {
        getConfig() {
            aliOss.getFile('config.json').then(r => {
                this.sortConfig = JSON.parse(r.content);
                this.search();
            })
        },
        search() {
            aliOss.getList(this.fileDire).then(f => {
                this.tableMode = JSON.parse(JSON.stringify(this.searchData));
                this.customTableSort(f.objects);
            })
        },
        customTableSort(arr) {
            if(this.sortConfig[this.searchData.product] && this.sortConfig[this.searchData.product][this.searchData.lang] && this.sortConfig[this.searchData.product][this.searchData.lang]['sort'] && this.sortConfig[this.searchData.product][this.searchData.lang]['sort'][this.module]) {
                const sortArr = this.sortConfig[this.searchData.product][this.searchData.lang]['sort'][this.module];
                arr.sort((item1, item2) => {
                    const index1 = sortArr.indexOf(item1.name.split('/').pop());
                    const index2 = sortArr.indexOf(item2.name.split('/').pop());
                    return index1 === -1 ? 1 : index2 === -1 ? -1 : index1 - index2;
                });
            }
            this.tableData = arr.filter(item => {
                return item.name.split(this.module + '/')[1] != '';
            })
        },
        add() {
            this.$refs.addFileDislog.show = true;
        },
        updateConfirm() {
            this.search();
            this.$refs.addFileDislog.show = false;
        },
        fileChange(file, type, i) {
        },
        delFile(dire) {
            this.delDire = dire;
            this.delMsg = '确认删除文件' + dire.split('/_').pop();
            this.$refs.tip.show = true;
        },
        delConfirm() {
            aliOss.delFile(this.delDire).then(r => {
                this.search();
            });
        },
        inSortMode() {
            this.sortState = true;
        },
        sort(i, type) {
            let index1, index2;
            index1 = i;
            index2 = type == 'up' ? i - 1 : i + 1;
            const temp = this.tableData[index1];
            this.$set(this.tableData, index1, this.tableData[index2]);
            this.$set(this.tableData, index2, temp);
        },
        sortConfirm() {
            this.tableData.forEach(item => {
                this.sortData.push(item.name.split('/').pop());
            })
            if(!this.sortConfig[this.searchData.product]) {
                this.sortConfig[this.searchData.product] = {
                    [this.searchData.lang]: {}
                };
            }else if(!this.sortConfig[this.searchData.product][this.searchData.lang]) {
                this.sortConfig[this.searchData.product][this.searchData.lang] = {};
                this.sortConfig[this.searchData.product][this.searchData.lang].sort = {};
            }else if(!this.sortConfig[this.searchData.product][this.searchData.lang].sort) {
                this.sortConfig[this.searchData.product][this.searchData.lang].sort = {}
            }
            this.sortConfig[this.searchData.product][this.searchData.lang]['sort'][this.module] = this.sortData;
            aliOss.putFile('config.json', this.sortConfig, 'application/json').then(r => {
                this.sortData = [];
                this.sortState = false;
            })
        },
        sortCancel() {
            this.search();
            this.sortState = false;
        }
    }
})
</script>
<style lang="less" scoped>
    .setting_box{
        max-width: 400px;
    }
    .btn_right_box{
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/guide-manage.vue